module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.D. Cain\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("R.D. Cain")]), _vm._v(" has worked for the last 18 years in the emergency services as a paramedic, firefighter, and police officer. He lives in Scarborough, Ontario.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KmYdRW/tc-custom/9781554909773.jpg?1734290702720",
      "alt": "This image is the cover for the book Cherry Beach Express, The Steve Nastos Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cherry Beach Express, The Steve Nastos Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A police detective is accused of murder in this novel that “delivers on all levels: action, courtroom drama . . . and a show-stopping climax” ("), _c('i', [_vm._v("The Hamilton Spectator")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Until recently, Steve Nastos was a respected Toronto detective, part of the sexual assault unit. Now he’s in custody—accused of killing his young daughter’s dentist after learning of the man’s unspeakable crimes against children."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Freed on bail, he has one hope: to track down the actual killer, in a town where laws are seen more as guidelines and law enforcement agents adhere to their own moral relativism. Handicapped by a recovering alcoholic lawyer, a rogue cop, and a two-faced judge, Nastos has the cards stacked against him. Then his estranged but still beloved wife inadvertently becomes involved in the case, and the stakes become even higher."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" He has to protect his family—but first he has to save himself . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ECW Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0